/**
 * オプション詳細（プラン画面）
 */
export class OptionInfo {
	// public 変数	-----------------------------------------------------------
	private m_OptionFee: number			= null		// オプション料金
	private m_Value7: string			= null		// 
	private m_EmergencyCost: string		= null		// 緊急費用（オプション）
	private m_LodgingCost: string		= null		// 宿泊費用（オプション）
	// ------------------------------------------------------------------------

	// プロパティ  --------------------------------------------------------------
	/** オプション料金（number）*/
	public get optionFee(): number { return this.m_OptionFee; }
	public set optionFee(optionFee: number) { this.m_OptionFee = optionFee; }

	public get value7(): string { return this.m_Value7;}
	public set value7(value7: string) { this.m_Value7 = value7;}

	/** 緊急費用(オプション) */
	public get emergencyCost(): string { return this.m_EmergencyCost; }
	public set emergencyCost(emergencyCost: string) { this.m_EmergencyCost = emergencyCost; }
	/** 宿泊費用(オプション) */
	public get lodgingCost(): string { return this.m_LodgingCost; }
	public set lodgingCost(lodgingCost: string) { this.m_LodgingCost = lodgingCost; }
	// --------------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() {}
	// -----------------------------------------------------------------------
}